import * as React from "react";

function SvgFacebookFilled(props) {
  return (
    <svg
      width="2em"
      height="2em"
      viewBox="0 0 48 48"
      fill="currentColor"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#3C5A9A"
          d="M42.397 42.396c-2.314 2.432-5.407 3.912-9.279 4.44-2.717.556-5.831.788-9.343.694-3.512.094-6.626-.138-9.343-.695-3.872-.527-6.965-2.007-9.278-4.439-2.432-2.314-3.911-5.406-4.44-9.278-.556-2.717-.787-5.831-.694-9.343-.093-3.512.138-6.626.695-9.343.528-3.872 2.007-6.965 4.439-9.278 2.313-2.432 5.406-3.912 9.278-4.44 2.717-.556 5.831-.787 9.343-.694 3.512-.093 6.626.138 9.343.695 3.872.527 6.965 2.007 9.279 4.439 2.43 2.313 3.91 5.406 4.438 9.278.557 2.717.789 5.831.695 9.343.094 3.512-.138 6.626-.695 9.343-.527 3.872-2.007 6.964-4.438 9.278z"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M25.584 34.5V24.237h3.445l.516-4h-3.96v-2.554c0-1.158.32-1.947 1.982-1.947l2.118-.001v-3.578A28.898 28.898 0 0026.598 12c-3.053 0-5.144 1.864-5.144 5.287v2.95H18v4h3.454V34.5h4.13z"
        />
      </g>
    </svg>
  );
}

export default SvgFacebookFilled;
